export const TALKDESK_END_SESSION_UNAUTHORIZED = 'talkdesk_end_session_unauthorized'
export const NO_EXTERNAL_ID = 'no_external_id'
export const DIFFERENT_EXTERNAL_IDS = 'different_external_ids'
export const FAILED_TALKDESK_EXTERNAL_ID_FETCH = 'failed_talkdesk_external_id_fetch'
export const FAILED_TALKDESK_EXTERNAL_ID_FETCH_BY_SEAT = 'failed_talkdesk_external_id_fetch_by_seat'
export const FAILED_LOGIN = 'failed_login'
export const INVALID_ACCOUNT = 'invalid_account'
export const USER_LOGOUT_FORCED = 'user_logout_forced'
export const MISMATCHED_INTEGRATION_ERROR = 'mismatched_integration_error'
